/**
 * DevExtreme (esm/__internal/ui/tabs/constants.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var TABS_EXPANDED_CLASS = "dx-tabs-expanded";
